"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withField;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Strings = require("@phg/stilo-utils/Strings");

var _FormFeedback = _interopRequireDefault(require("../../component/FormFeedback"));

var _Label = _interopRequireDefault(require("../../component/Label"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

function withField(WrappedComponent) {
  // eslint-disable-next-line complexity
  var WithFieldWrapper = function WithFieldWrapper(_ref) {
    var label = _ref.label,
        className = _ref.className,
        labelClassName = _ref.labelClassName,
        wrapperClassName = _ref.wrapperClassName,
        componentClassName = _ref.componentClassName,
        error = _ref.error,
        warning = _ref.warning,
        optional = _ref.optional,
        _ref$optionalLabel = _ref.optionalLabel,
        optionalLabel = _ref$optionalLabel === void 0 ? 'optional' : _ref$optionalLabel,
        disabled = _ref.disabled,
        id = _ref.id,
        readOnly = _ref.readOnly,
        rest = (0, _objectWithoutProperties2["default"])(_ref, ["label", "className", "labelClassName", "wrapperClassName", "componentClassName", "error", "warning", "optional", "optionalLabel", "disabled", "id", "readOnly"]);
    var classes = useStyles();

    var wrappedComponentProps = _objectSpread(_objectSpread({}, rest), {}, {
      disabled: disabled,
      readOnly: readOnly,
      className: (0, _classnames["default"])(classes.WrappedComponent, componentClassName),
      id: id
    });

    if (error) wrappedComponentProps['data-has-errors'] = true;
    if (!!warning && !error) wrappedComponentProps['data-has-warnings'] = true;
    return /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames["default"])(classes.WithFieldWrapper, className)
    }, label && /*#__PURE__*/React.createElement(_Label["default"], {
      className: (0, _classnames["default"])(classes.Label, labelClassName),
      htmlFor: id
    }, label), /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames["default"])(classes.WithFieldInnerWrapper, wrapperClassName)
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.OptionalHelper
    }, /*#__PURE__*/React.createElement(WrappedComponent, wrappedComponentProps), optional ? /*#__PURE__*/React.createElement("div", {
      className: classes.Optional
    }, optionalLabel) : null), !!error && /*#__PURE__*/React.createElement(_FormFeedback["default"], {
      kind: "error",
      className: classes.FormFeedback,
      id: (0, _Strings.suffixIfSubject)(id, '-form-feedback-error')
    }, error), !!warning && !error && /*#__PURE__*/React.createElement(_FormFeedback["default"], {
      kind: "warning",
      className: classes.FormFeedback,
      id: (0, _Strings.suffixIfSubject)(id, '-form-feedback-warning')
    }, warning)));
  };

  return WithFieldWrapper;
}
//# sourceMappingURL=index.js.map